import React, { useEffect, useState, useCallback } from "react";
import DashboardLayout from "../../molecules/DashboardLayout";
import { bookingStatuses, listFilterConfigWithPortfolioUnits } from "../../../utils/helper";
import { Row, Col, Pagination, Card, Select, message, Typography } from "antd";
import { SectionHeaderV2 } from "../../organism/SectionHeaderV2";
import Grid from "../../atoms/Grid";
import DragAndDropList from "../../atoms/Grid/gridColumnSort";
import { useSelector, useDispatch } from "react-redux";
import LoaderTsx from "../Loader.tsx";
import { getBookingForms, sendTenantInvite, updateBookingStatus } from "./ducks/actions";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "../../../utils/axiosInceptor";
import { baseContractService } from "../../../configs/constants";
import { emptyPropertyUnits, getBookingUnitList, getPropertyUnits } from "../Properties/PropertyDetail/ducks/actions";
import { useSearchHistory } from "../../../utils/filterHelper";
import { setFilterBooking } from "../App/SearchFilters/ducks/actions";

import { useBookingsSearch } from "./hooks";
import { searchByOptions as baseSearchByOptions } from "./constants/searchByOptions";
import { useFeatureToggleSearchByOptions } from "../../../hooks/search";
import { bookingCol, bookingColumn } from "./bookingColumn";
import { getGridSettings } from "../../../utils/globalService";
import { getOrgByID } from "../../modules/Maintenance/Tickets/ducks/actions";
import { useGridReset } from "../../../hooks/useGridReset";
import { PopupConfirm } from "../../atoms/Popup";
import { BookingFiltersState, FilterOption, useListingFilters } from "../../../hooks/useListingFilters";
import { getPropertiesDrop } from "../Properties/ducks/actions";
import { GridType } from "../../../types/grid";
import { RootState } from "../../../redux/store";

const gridProps = {
  resizable: true,
};

const dropDown = [
  { id: 2, name: "Edit", status: "" },
  { id: 3, name: "Send To Tenant", status: "" },
  { id: 4, name: "Cancel", status: "#FB7171" },
];

const dropDownRenewal = [, { id: 2, name: "Edit", status: "" }, { id: 4, name: "Cancel", status: "#FB7171" }];

const dropDown1 = [, { id: 2, name: "Edit", status: "" }];
const dropDown2 = [{ id: 2, name: "View Confirmed Form", status: "" }];
const dropDown3 = [{ id: 4, name: "View Approved Form", status: "" }];
const limit = 50;

const BookingListing = () => {
  const dispatch: any = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const { state } = useLocation();
  const listBooking = useSelector((state: any) => state.booking.bookingList);
  const propertyList = useSelector((state: any) => state.dashboard.propertiesDrop || []);
  const bookingUnits = useSelector((state: any) => state.propertyDetails.bookingUnitsDropdown || []);
  const portfolioUnits = useSelector((state: any) => state.propertyDetails.unitsDropdown || []);
  const propertyOptions: FilterOption[] = propertyList;
  const [unitLoading, setUnitLoading] = useState(false);
  const [bookingStatus, setBookingStatusFilter] = useState<{ value: string } | null>(null);
  const [cancelledbookingCheckBox, setCancelledBookingCheckBox] = useState(false);
  const filter = useSelector((state: any) => state.filters.bookingsData);
  const [selectedSearchBy, setSelectedSearchBy] = useState(Object.keys(filter)[0] ?? "unitCode");
  const [searchValue, setSearchValue] = useState(
    state?.clear == true ? "" : state?.unitId || filter[Object.keys(filter)[0]] || "",
  );
  const [bookingColumns, setBookingColumns] = useState<GridType[]>([]);
  const [detectColumnChanges, setDetectColumnChanges] = useState(false);
  const { selectOptions, handleSearch, handleChangeSearchBy } = useBookingsSearch({
    selectedSearchBy,
    setSelectedSearchBy,
    setSearchValue,
  });

  const { searchHistory, addToSearchHistory } = useSearchHistory(setFilterBooking as any);
  const organization = useSelector((state: RootState) => state?.tickets?.orgData);
  const { resetGrid, setGridReset } = useGridReset();
  const [exportData, setExportData] = useState(false);

  const getGridConfig = async (column) => {
    let result = await getGridSettings("booking", column, resetGrid);
    if (result?.length) {
      setBookingColumns(result);
      setGridReset(false);
    }
  };

  const listingFilterConfig = useCallback(
    (state: BookingFiltersState) =>
      listFilterConfigWithPortfolioUnits({
        state,
        propertyOptions,
        portfolioUnits,
        bookingUnits,
        portfolioUnitsLoading: unitLoading,
      }),
    [propertyOptions, portfolioUnits, bookingUnits, unitLoading],
  );

  // ✅ use generic hook
  const { viewOption, handleFilterChange, updateValue, filtersState } = useListingFilters<BookingFiltersState>({
    initialState: {
      usagesType: { value: "all", label: "All" },
      property: { value: "all", label: "All" },
      unit: { value: "all", label: "All" },
    },

    configBuilder: listingFilterConfig,

    handlers: {
      property: ({ option, setState, setUpdateValue }) => {
        setState((prev) => ({
          ...prev,
          property: option,
          unit: null,
        }));

        setUpdateValue({ label: "unit", value: null });
        const pid = option?.value;
        if (pid && pid !== "all" && pid !== "") {
          dispatch(getBookingUnitList(pid));
        } else {
          dispatch(getPropertyUnits(null, null, false, setUnitLoading));
        }
      },
    },
  });

  const fetchBookingList = (params) => {
    dispatch(getBookingForms(params));
  };

  useEffect(() => {
    const buildLeaseColumnsWithKyc = async (org) => {
      const kycFields = [...(org?.commercialKycForm || []), ...(org?.residentialKycForm || [])].filter(
        (field, index, self) => index === self.findIndex((f) => f.name === field.name),
      );

      const dynamicKycCols = kycFields.map((field, index) => ({
        id: 55 + index,
        headerName: field.label,
        field: `kycDetails.${field.name}`,
        checked: false,
        hide: true,
      }));

      const mergedLeaseCols = [...bookingCol, ...dynamicKycCols];
      getGridConfig(mergedLeaseCols);
      setBookingColumns(mergedLeaseCols);
    };

    const init = async () => {
      const isOrgEmpty = !organization || (typeof organization === "object" && Object.keys(organization).length === 0);

      if (isOrgEmpty) {
        const orgData = localStorage?.getItem("login-response");
        const orgId = orgData ? JSON.parse(orgData) : null;
        if (orgId) {
          await dispatch(getOrgByID(orgId?.orgId));
        }
      } else {
        buildLeaseColumnsWithKyc(organization);
      }
    };
    init();
  }, [organization, resetGrid]);

  useEffect(() => {
    dispatch(getPropertiesDrop());
    dispatch(getPropertyUnits(null, null, false, setUnitLoading));
    return () => {
      dispatch(emptyPropertyUnits());
    };
  }, []);

  const sendToTenant = async (email, leaseId) => {
    if (email && leaseId) {
      let payload = [
        {
          email: email,
          usertype: "tenant",
          inviteAll: false,
          leaseId: leaseId,
        },
      ];
      let successMessage = "Invite sent to tenant successfully";
      const status = await sendTenantInvite(payload);
      if (status === 200) {
        const res = await updateBookingStatus(leaseId, {
          status: "tenant_invitation_sent",
        });
        if (res === 200) {
          message.success(successMessage);
          setIsLoading(true);
          dispatch(
            fetchBookingList({
              limit,
              page: currentPage,
              value: searchValue,
              field: selectedSearchBy,
              bookingStatus: getBookingStatuesForFilter(),
              propertyId: undefined,
              unitId: undefined,
              setIsLoading,
            }),
          );
        }
      }
    } else {
      message.error("No email id present");
    }
  };

  //  check booking statuses if all then bookingStatus must be null
  const getBookingStatuesForFilter = () => {
    if (!bookingStatus || bookingStatus?.value === "all") {
      return "";
    } else {
      bookingStatus?.value === "booking_cancelled" && setCancelledBookingCheckBox(true);
      return bookingStatus?.value;
    }
  };

  useEffect(() => {
    addToSearchHistory(selectedSearchBy, searchValue); //adding search history and filter store
    let cancelleBookingInclude = cancelledbookingCheckBox ? "yes" : "no";
    setIsLoading(true);
    fetchBookingList({
      limit,
      page: currentPage,
      value: searchValue,
      field: selectedSearchBy,
      bookingStatus: getBookingStatuesForFilter(),
      cancelleBookingInclude,
      usagesType: filtersState.usagesType?.value === "all" ? "" : filtersState.usagesType?.value,
      propertyId: filtersState.property?.value === "all" ? "" : filtersState.property?.value,
      unitId: filtersState.unit?.value === "all" ? "" : filtersState.unit?.value,
      exportData,
      setExportData,
      totalCount: listBooking?.totalCount,
      bookingColumns,
      setIsLoading,
    });
  }, [
    searchValue,
    bookingStatus,
    filtersState.usagesType?.value,
    filtersState.property?.value,
    filtersState.unit?.value,
    cancelledbookingCheckBox,
    currentPage,
    bookingColumns,
    exportData,
  ]);

  const handlePagination = (pg) => {
    setCurrentPage(pg);
  };

  const { searchByOptions } = useFeatureToggleSearchByOptions(baseSearchByOptions);

  useEffect(() => {
    let key = Object.keys(searchHistory)[0];
    if (searchByOptions.length > 0)
      searchByOptions.map((item) => {
        if (key == item.value) item["default"] = true;
        else item["default"] = false;
        return item;
      });
  }, [searchHistory]);

  const onDownload = async (id) => {
    let url = `${baseContractService}/download-booking-form/${id}`;
    await axios
      .get(url)
      .then((response) => {
        if (response?.data?.result?.imageUrl != "https://s3.ap-south-1.amazonaws.com/") {
          window.open(response?.data?.result?.imageUrl);
        } else {
          onDownload(id);
        }
      })
      .catch((e) => {
        const { response } = e;
        message.error(response.data.message);
      });
  };

  const onCancelBookingForm = async (leaseId) => {
    const res = await updateBookingStatus(leaseId, {
      status: "booking_reject",
    });
    if (res === 200) {
      message.success("Booking has been cancelled");
      setIsLoading(true);
      dispatch(
        fetchBookingList({
          limit,
          page: currentPage,
          value: searchValue,
          field: selectedSearchBy,
          bookingStatus: getBookingStatuesForFilter(),
          propertyId: undefined,
          unitId: undefined,
          setIsLoading,
        }),
      );
    }
  };
  const onStatus = (leaseId) => {
    PopupConfirm({
      title: "Are you sure you want to cancel?",
      onOk: () => onCancelBookingForm(leaseId),
      okText: "Yes",
    });
  };
  const MoreAction = (row) => {
    const dispatch: any = useDispatch();
    const navigate = useNavigate();
    const { Text } = Typography;

    const onChangeHandler = async (e) => {
      if (e === "Cancel") {
        onStatus(row.data.leaseId);
      } else if (e === "Add Unit") {
      } else if (e === "Download booking form") {
      } else if (e === "Send To Tenant") {
        if (row.data?.tenantDetails?.email && row.data?.leaseId)
          sendToTenant(row.data.tenantDetails.email, row.data.leaseId);
      } else if (e === "View Confirmed Form") {
        navigate(`/viewbookingform/${row.data.leaseId}`);
      } else if (e === "View Approved Form") {
        navigate(`/viewbookingform/${row.data.leaseId}`);
      } else if (e === "Edit") {
        if (row?.data?.leaseStatus === "draft") navigate(`/newbookingform/${row.data.leaseId}`);
        else navigate(`/viewbookingform/${row.data.leaseId}`);
      } else if (e === "Send for tenant's signature") {
        try {
          let body = { leadId: row.data.id };
          await axios.post(`${baseContractService}/booking-form-send-to-prospect`, body);
          message.success("Successfully Sent");
        } catch (e: unknown) {
          if (axios.isAxiosError(e)) {
            message.error(e.response?.data?.message);
          } else {
            message.error("Something went wrong");
          }
        }
      }
    };

    return (
      <Select
        onChange={onChangeHandler}
        className="Sentence"
        placeholder="Select an action"
        style={{ width: 150 }}
        allowClear
      >
        <>
          {row.data.leaseStatus === "booking_created" &&
            (row.data.leaseType == "renewal"
              ? dropDownRenewal.map((value, key) => (
                  <React.Fragment key={key}>
                    <Select.Option value={value?.name}>
                      <Text style={{ color: `${value?.status}` }}>{value?.name}</Text>
                    </Select.Option>
                  </React.Fragment>
                ))
              : dropDown.map((value, key) => (
                  <React.Fragment key={key}>
                    <Select.Option value={value?.name}>
                      <Text style={{ color: `${value?.status}` }}>{value?.name}</Text>
                    </Select.Option>
                  </React.Fragment>
                )))}
          {row.data.leaseStatus !== "booking_created" &&
            row.data.leaseStatus !== "booking_confirmed" &&
            row.data.leaseStatus !== "booking_approved" &&
            dropDown1.map((value, key) => (
              <React.Fragment key={key}>
                <Select.Option value={value?.name}>
                  <Text style={{ color: `${value?.status}` }}>{value?.name}</Text>
                </Select.Option>
              </React.Fragment>
            ))}
          {row.data.leaseStatus === "booking_confirmed" &&
            dropDown2.map((value, key) => (
              <React.Fragment key={key}>
                <Select.Option value={value?.name}>
                  <Text style={{ color: `${value?.status}` }}>{value?.name}</Text>
                </Select.Option>
              </React.Fragment>
            ))}
          {row.data.leaseStatus === "booking_approved" &&
            dropDown3.map((value, key) => (
              <React.Fragment key={key}>
                <Select.Option value={value?.name}>
                  <Text style={{ color: `${value?.status}` }}>{value?.name}</Text>
                </Select.Option>
              </React.Fragment>
            ))}
        </>
      </Select>
    );
  };

  return (
    <DashboardLayout>
      <Row gutter={[32, 32]}>
        <Col span={24}>
          <Row gutter={[24, 24]}>
            <Col span={24}>
              <SectionHeaderV2
                heading="Bookings"
                total={listBooking?.totalCount || 0}
                cancelledBookingCheck={true}
                viewOption={viewOption}
                bookingStatus={true}
                bookingStatusTitle={"Filter By Booking Status"}
                bookingStatuses={bookingStatuses}
                onSearch={handleSearch}
                onChangeSearchBy={handleChangeSearchBy}
                defaultSearch={searchValue}
                searchByOptions={searchByOptions}
                selectOptions={selectOptions}
                justifiedItems={true}
                justifyEnd={true}
                handleView={handleFilterChange}
                updateValue={updateValue}
                bookingStatusFilter={setBookingStatusFilter}
                bookingStatusFlag={bookingStatus}
                setCheckBoxValue={setCancelledBookingCheckBox}
                checkBoxValue={cancelledbookingCheckBox}
                filterStyle={{ marginRight: "10px" }}
                downloadAction={() => setExportData(true)}
              />
            </Col>
            <Col span={23}>
              <Pagination
                className="ag-property-text-pagination"
                total={listBooking?.totalCount || 0}
                showTotal={(total, range) => `Showing ${range[0]}-${range[1]} of ${total} bookings`}
                defaultPageSize={50}
                defaultCurrent={1}
                showSizeChanger={false}
                current={currentPage}
                onChange={(e) => handlePagination(e)}
              />
            </Col>
            <Col span={1}>
              <div style={{ display: "flex", justifyContent: "end" }}>
                <DragAndDropList
                  columns={bookingColumns}
                  setModifiedColumns={setBookingColumns}
                  changePicker={setDetectColumnChanges}
                  detectColumnChanges={detectColumnChanges}
                  screenName="booking"
                  setGridReset={setGridReset}
                />
              </div>
            </Col>
            <Col span={24}>
              <Row gutter={[24, 24]} justify="end">
                <Col span={24}>
                  <Card bordered={false} className="ag-nospace-body">
                    {isLoading ? (
                      <LoaderTsx />
                    ) : (
                      <Grid
                        refCol="status"
                        data={listBooking?.data ?? []}
                        columns={bookingColumn(bookingColumns, MoreAction)}
                        pagination={false}
                        defaultSettings={gridProps}
                        noRowlabel="Booking"
                        fullPage={true}
                      />
                    )}
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </DashboardLayout>
  );
};

export default BookingListing;
